import { Route } from '@angular/router';
import { FeatureRouteEnum } from './feature/feature-routes.enum';
import { AuthGuard, EnumPermissions, Layout, userResolver } from '@olymp/shared';
import { menu } from './feature/menu';
import { environment } from '../environments/environment.development';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./feature/landing/pages/landing-page/landing-page.component'),
  },
  {
    path: 'winners',
    loadComponent: () =>
      import('./feature/landing/pages/winners-page/winners-page.component').then(
        (m) => m.WinnersPageComponent
      ),
  },
  {
    path: 'materials',
    loadComponent: () =>
      import('./feature/landing/pages/materials-page/materials-page.component').then(
        (m) => m.MaterialsPageComponent
      ),
  },
  {
    path: 'subjects',
    loadComponent: () =>
      import('./feature/landing/pages/subjects-page/subjects-page.component').then(
        (m) => m.SubjectsPageComponent
      ),
  },
  {
    path: `${FeatureRouteEnum.LICENSE_STUDENT}/:fileId`,
    loadComponent: () =>
      import(
        './feature/license-student/pages/license-student-viewer/license-student-viewer.component'
      ),
  },
  {
    path: FeatureRouteEnum.SIGN_IN_REDIRECT,
    pathMatch: 'full',
    redirectTo: FeatureRouteEnum.PROFILE,
  },
  {
    path: '',
    canActivateChild: [AuthGuard],
    component: Layout,
    resolve: { userData: userResolver },
    data: { menuItems: menu },
    children: [
      {
        path: FeatureRouteEnum.PROFILE,
        loadChildren: () => import('./feature/profile/profile-route'),
        data: { breadcrumb: 'my_profile' },
      },
      {
        path: FeatureRouteEnum.OLYMPIAD,
        loadChildren: () => import('./feature/olympiad/olympiad-route'),
        data: { breadcrumb: FeatureRouteEnum.OLYMPIAD },
      },
      {
        path: FeatureRouteEnum.APPLICATIONS,
        loadChildren: () => import('@olymp/applications'),
        data: { breadcrumb: FeatureRouteEnum.APPLICATIONS, isUser: true },
      },
      {
        path: FeatureRouteEnum.SPECIAL_USERS,
        loadChildren: () => import('@olymp/special-user'),
        data: { breadcrumb: FeatureRouteEnum.SPECIAL_USERS },
      },
      {
        path: FeatureRouteEnum.APPELLATION,
        loadChildren: () => import('./feature/appellation/appellation-route'),
        data: { breadcrumb: FeatureRouteEnum.APPELLATION },
      },
      {
        path: FeatureRouteEnum.APPLICATION_GROUP,
        loadChildren: () =>
          import('./feature/application-group/application-group.routes').then(
            (m) => m.APPLICATION_GROUP_ROUTES,
          ),
        data: { breadcrumb: 'application_group' },
      },
      {
        path: FeatureRouteEnum.OLYMPIAD_TEAM,
        loadChildren: () =>
          import('./feature/olympiad-team/olympiad-team.routes').then(
            (m) => m.OLYMPIAD_TEAM_ROUTES,
          ),
        data: {
          breadcrumb: 'olympiad_team_formation',
          permissions: {
            get: EnumPermissions.AdvancedEngineeringOlympiadGet,
            teamCreate: EnumPermissions.AdvancedEngineeringOlympiadTeamCreate,
          },
        },
      },
      {
        path: FeatureRouteEnum.STEP_TO_INVENTION,
        loadChildren: () =>
          import('./feature/step-to-invention/step-to-invention.routes').then(
            (m) => m.STEP_TO_INVENTION_ROUTES,
          ),
        data: {
          breadcrumb: 'step_to_invention_projects',
          permissions: {
            menu: EnumPermissions.StepToInventionProjectUserMenu,
          },
        },
      },
      {
        path: FeatureRouteEnum.RESULTS,
        loadChildren: () => import('./feature/results/results-route'),
        data: { breadcrumb: 'results' },
      },
      {
        path: FeatureRouteEnum.DEMO_TESTS,
        loadChildren: () => import('./feature/demo-tests/demo-tests-route'),
        data: {
          breadcrumb: 'demo_tests',
          permissions: {
            get: EnumPermissions.DemoTestView,
          },
        },
      },
    ],
  },
  {
    path: FeatureRouteEnum.AUTH,
    loadChildren: () => import('@olymp/authRoute'),
    data: {
      url: environment.API_BASE_PUBLIC_URL,
      type: environment.type,
    },
  },
  {
    path: '**',
    loadComponent: () =>
      import('@olymp/shared').then((m) => m.PageNotFoundComponent),
  },
];
